// Copyright 2021 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.

export class ValidatorPatterns {
  public static WorkspaceName = '^[a-zA-Z0-9-_.]+$';
}
